import { Card, Col, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BannerCard from "../../../common/components/BannerCard";
import { civilRequest } from "../../../state/connect-api";
import { useCivilCaseDefendantMutation } from "../../../state/globalApi";
import { setCivilMaster } from "../../../state/globalStore";
import { RootState } from "../../../store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import getConfigs from "../../../GetConfigs";

const CivilDefendant = ({ ...props }) => {
  const { activeCaseNumber, civilMaster } = useSelector((state: RootState) => state.global);
  const dispatch = useDispatch();
  const [getCaseDefendant, { isLoading }] = useCivilCaseDefendantMutation();
  const [messageVisible, setMessageVisible] = useState<boolean>(true)
  const configurations = getConfigs([
    "ctCVLDefendantTxt",
  ]);

  useEffect(() => {
    const lookupRequest = civilRequest(activeCaseNumber);
    const fetch = async () => {
      const defendant = await getCaseDefendant(lookupRequest).unwrap();
      dispatch(setCivilMaster({ defendant: defendant }));
    };

    fetch();
  }, [activeCaseNumber, dispatch]);

  const columns = [
    { key: "name", dataIndex: "CaseParticipantName", title: "Name" },
    { key: "PhysicalAddress1", dataIndex: "PhysicalAddress1", title: "Address" },
    { key: "AttorneyName", dataIndex: "AttorneyName", title: "Attorney" }
  ];

  return (
    <Row gutter={[16, 16]}>
      {configurations.ctCVLDefendantTxt && messageVisible && (
        <Col xl={23} lg={23} md={23} sm={23} xs={23}>
          <Card>
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "end" }}>
              <FontAwesomeIcon icon={"times"} onClick={() => setMessageVisible(false)} />
            </div>
            <br />
            <div dangerouslySetInnerHTML={{ __html: configurations.ctCVLDefendantTxt }} />
          </Card>
        </Col>
      )}
      <Col xl={23} lg={23} md={23} sm={23} xs={23}>
        <BannerCard title="Defendants">
          <Table loading={isLoading} columns={columns} dataSource={civilMaster?.defendant?.LIST} scroll={{ x: 720 }} size="small" />
        </BannerCard>
      </Col>
    </Row>
  );
};

export default CivilDefendant;
